import { Mutations } from "vuex-smart-module";
import { MutationTypes } from "../mutations-types";
import { IUserProfile } from "../user/models";
import UserAdminState from "./state";

export default class UserAdminMutations extends Mutations<UserAdminState> {
  [MutationTypes.USER_LIST](list: IUserProfile[]) {
    this.state.userList = list;
  }
  [MutationTypes.TOKEN_LIST](list: number[]) {
    this.state.availableTokenList = list;
  }
}
